import React from "react";

export const DashboardStyles: React.FC = () => {
  return (
    <style>{`
      @import url('https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@500;600;700&family=Inter:wght@400;500;600;700&family=JetBrains+Mono:wght@400;600&display=swap');
      
      body {
        font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
      }
      
      .font-space-grotesk {
        font-family: 'Space Grotesk', system-ui, sans-serif;
      }
      
      .font-jetbrains-mono {
        font-family: 'JetBrains Mono', ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New', monospace;
      }

      @keyframes float {
        0%, 100% {
          transform: translateY(0) translateX(0) rotate(0deg);
        }
        50% {
          transform: translateY(-80px) translateX(20px) rotate(180deg);
        }
      }

      @keyframes pulse {
        0%, 100% {
          transform: scale(1);
          opacity: 1;
        }
        50% {
          transform: scale(0.8);
          opacity: 0.4;
        }
      }

      @keyframes gridOn {
        to {
          background-size: 40px 40px;
        }
      }

      .animate-float {
        animation: float 24s infinite ease-in-out;
      }

      .animate-pulse-dot {
        animation: pulse 1.6s infinite;
      }

      .animate-grid-on {
        animation: gridOn 0.8s ease forwards;
      }

      ::-webkit-scrollbar {
        width: 7px;
        height: 7px;
      }

      ::-webkit-scrollbar-track {
        background: rgba(10, 14, 39, 0.8);
      }

      ::-webkit-scrollbar-thumb {
        background: rgba(0, 212, 255, 0.4);
        border-radius: 999px;
      }

      ::-webkit-scrollbar-thumb:hover {
        background: rgba(0, 212, 255, 0.7);
      }
    `}</style>
  );
};
